<template>
  <v-container fluid>
    <v-card class="pa-4">
      <!-- Header con botón Nuevo Usuario -->
      <div class="d-flex align-center mb-4">
        <v-icon color="#ce501b" size="large" class="mr-2">mdi-account-multiple</v-icon>
        <h2 class="text-h5">Gestión de Usuarios</h2>
        <v-spacer></v-spacer>
        <v-btn
          color="#ce501b"
          prepend-icon="mdi-account-plus"
          @click="abrirModalNuevoUsuario"
          elevation="2"
        >
          Nuevo Usuario
        </v-btn>
        <v-btn
          icon
          @click="recargarDesdeInicio"
          :loading="loading && usuarios.length === 0"
          color="#ffe8e1"
          class="ml-2"
        >
          <v-icon color="#ce501b">mdi-refresh</v-icon>
        </v-btn>
      </div>

      <!-- Buscador -->
      <v-text-field
        ref="campoBusquedaRef"
        v-model="busqueda"
        prepend-inner-icon="mdi-magnify"
        label="Buscar usuario..."
        variant="outlined"
        density="comfortable"
        clearable
        class="mb-4"
        @input="filtrarUsuarios"
      ></v-text-field>

      <!-- Tabla con infinite scroll -->
      <div 
        class="usuarios-container" 
        @scroll="handleScroll"
        ref="scrollContainer"
      >
        <!-- Tabla -->
        <v-table class="usuarios-table" fixed-header>
          <thead>
            <tr>
              <th class="text-center">Código</th>
              <th>Nombre de Usuario</th>
              <th class="text-center">Active Directory</th>
              <th class="text-center">Autenticación</th>
              <th>Grupo</th>
              <th>Oficina</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="(usuario, index) in usuariosFiltrados"
              :key="index"
              class="usuario-row"
              :class="{ 'inhabilitado': usuario.inhabilitado }"
            >
              <!-- Código -->
              <td class="text-center">
                <v-chip color="primary" size="small" label>
                  {{ usuario.idUsuario }}
                </v-chip>
              </td>

              <!-- Nombre de Usuario -->
              <td>
                <div class="d-flex align-center">
                  <v-icon class="mr-2" size="small">mdi-account</v-icon>
                  <strong>{{ usuario.usuario }}</strong>
                </div>
              </td>

              <!-- Active Directory -->
              <td class="text-center">
                <v-chip 
                  :color="usuario.flagDirectory ? 'success' : 'grey'" 
                  size="small"
                  label
                >
                  {{ usuario.flagDirectory ? 'Sí' : 'No' }}
                </v-chip>
              </td>

              <!-- Autenticación -->
              <td class="text-center">
                <span class="text-caption">{{ usuario.autenticacion || 'N/A' }}</span>
              </td>

              <!-- Grupo -->
              <td>
                <v-chip size="small" color="blue-grey" variant="tonal">
                  {{ usuario.grupo || 'Sin grupo' }}
                </v-chip>
              </td>

              <!-- Oficina -->
              <td>
                <div class="d-flex align-center">
                  <v-icon size="small" class="mr-1">mdi-office-building</v-icon>
                  <span class="text-caption">{{ usuario.nombreOficina || 'N/A' }}</span>
                </div>
              </td>

              <!-- Acciones -->
              <td class="text-center">
                <v-btn
                  icon
                  size="small"
                  color="blue"
                  variant="text"
                  @click="verPermisos(usuario)"
                  class="mr-1"
                >
                  <v-icon size="small">mdi-lock</v-icon>
                  <v-tooltip activator="parent" location="top">Ver Permisos</v-tooltip>
                </v-btn>

                <v-btn
                  icon
                  size="small"
                  color="orange"
                  variant="text"
                  @click="editarUsuario(usuario)"
                  class="mr-1"
                >
                  <v-icon size="small">mdi-pencil</v-icon>
                  <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                </v-btn>

                <v-btn
                  icon
                  size="small"
                  :color="usuario.idUsuario === '00001' ? 'grey' : 'red'"
                  variant="text"
                  @click="confirmarEliminar(usuario)"
                  :disabled="usuario.idUsuario === '00001'"
                >
                  <v-icon size="small">mdi-delete</v-icon>
                    <v-tooltip activator="parent" location="top">
                      {{ usuario.idUsuario === '00001' ? 'No se puede eliminar este usuario' : 'Eliminar' }}
                    </v-tooltip>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-table>

        <!-- Indicador de carga al final -->
        <div v-if="loading" class="text-center py-4">
          <v-progress-circular
            indeterminate
            color="primary"
            size="50"
          ></v-progress-circular>
          <p class="mt-2 text-caption">Cargando más usuarios...</p>
        </div>

        <!-- Mensaje cuando no hay más datos -->
        <div v-if="!loading && !hayMasDatos && usuarios.length > 0" class="text-center py-4 text-caption text-grey">
          <v-icon>mdi-check-circle</v-icon>
          No hay más usuarios para mostrar
        </div>

        <!-- Mensaje cuando no hay datos -->
        <div v-if="!loading && usuarios.length === 0" class="text-center py-8">
          <v-icon size="64" color="grey">mdi-account-off</v-icon>
          <p class="text-h6 text-grey mt-2">No hay usuarios registrados</p>
        </div>
      </div>
    </v-card>


   <!-- Modal Nuevo/Editar Usuario -->
    <v-dialog v-model="dialogNuevoUsuario" max-width="600px" persistent>
    <v-card>
        <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
        <!-- ✅ Título dinámico según el modo -->
        {{ modoEdicion ? 'Editar Usuario' : 'Registro de Usuario' }}
        <v-spacer></v-spacer>
        <v-btn
            icon
            @click="cerrarModal"
            size="small"
            variant="text"
            color="white"
        >
            <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">

         <!-- ✅ Alerta de error dentro del modal -->
          <v-alert
            v-if="errorDuplicado"
            type="warning"
            variant="tonal"
            closable
            class="mb-4"
            @click:close="errorDuplicado = ''"
          >
            {{ errorDuplicado }}
          </v-alert>

        <v-form ref="formNuevoUsuario" v-model="validFormNuevo">
            <!-- Usuario -->
            <v-text-field
            ref="campoUsuarioRef"
            v-model="nuevoUsuario.usuario"
            label="Usuario"
            prepend-icon="mdi-account"
            variant="outlined"
            density="comfortable"
            :rules="[v => !!v || 'Usuario es requerido']"
            class="mb-3 campo-amarillo"
            ></v-text-field>

            <!-- Clave - Opcional en modo edición -->
            <v-text-field
            v-model="nuevoUsuario.password"
            :append-inner-icon="showPasswordNuevo ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPasswordNuevo ? 'text' : 'password'"
            :label="modoEdicion ? 'Clave (dejar vacío para no cambiar)' : 'Clave'"
            prepend-icon="mdi-lock"
            variant="outlined"
            density="comfortable"
            :rules="modoEdicion ? passwordRulesEdicion : passwordRulesNuevo"
            @click:append-inner="showPasswordNuevo = !showPasswordNuevo"
            :class="modoEdicion ? 'mb-3' : 'mb-3 campo-amarillo'"
            :hint="modoEdicion ? 'Deja vacío si no deseas cambiar la contraseña' : ''"
            persistent-hint
            ></v-text-field>

            <!-- Correo -->
            <v-text-field
            v-model="nuevoUsuario.correo"
            label="Correo"
            prepend-icon="mdi-email"
            variant="outlined"
            density="comfortable"
            :rules="[
                v => !v || /.+@.+\..+/.test(v) || 'Correo debe ser válido'
            ]"
            class="mb-3"
            ></v-text-field>

            
            <!-- Selector Grupo -->
            <v-select
            v-model="nuevoUsuario.idGrupo"
            :items="grupos"
            item-title="grupo"
            item-value="idGrupo"
            label="Seleccione un grupo"
            prepend-icon="mdi-account-group"
            variant="outlined"
            density="comfortable"
            clearable
            class="mb-3"
            :return-object="false"
            ></v-select>

            <!-- Selector Oficina -->
            <v-select
            v-model="nuevoUsuario.idOficina"
            :items="oficinas"
            item-title="oficina"
            item-value="idOficina"
            label="Seleccione una oficina"
            prepend-icon="mdi-office-building"
            variant="outlined"
            density="comfortable"
            clearable
            class="mb-3"
            :return-object="false"
            ></v-select>

            <!-- Permisos -->
            <div class="permisos-section">
            <v-checkbox
                v-model="nuevoUsuario.emailActivo"
                label="Recepcion de Email"
                density="compact"
                hide-details
                class="mb-2"
            ></v-checkbox>

            <v-checkbox
                v-model="nuevoUsuario.inhabilitado"
                label="Desactivar Usuario"
                density="compact"
                hide-details
                :disabled="modoEdicion && usuarioEditando?.idUsuario === '00001'"
            ></v-checkbox>
            </div>
        </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-4">
        <v-spacer></v-spacer>
   
        <v-btn
            type="button"
            color="#ce501b"
            variant="elevated"
            @click="guardarUsuario"
            :loading="guardando"
            :disabled="!validFormNuevo"
        >
            {{ modoEdicion ? 'Actualizar' : 'Grabar' }}
        </v-btn>

            <v-btn
            type="button"
            color="#9B9B9B"
            variant="elevated"
            @click="cerrarModal"
        >
            Cancelar
        </v-btn>

        </v-card-actions>
    </v-card>
    </v-dialog>

  <!-- Modal Ver Permisos -->
<v-dialog v-model="dialogVerPermisos" max-width="900px" persistent>
  <v-card>
    <v-card-title class="text-h6 text-white" style="background-color: #004d82;">
      <v-icon class="mr-2">mdi-lock</v-icon>
      Listado de permisos
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="cerrarModalPermisos"
        size="small"
        variant="text"
        color="white"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-4">
      <div v-if="usuarioSeleccionado" class="mb-4">
        <v-chip color="primary" label class="mr-2">
          <v-icon start>mdi-account</v-icon>
          {{ usuarioSeleccionado.usuario }}
        </v-chip>
        <span class="text-caption text-grey">
          Total de permisos: {{ todosLosPermisos.length }}
        </span>
      </div>

      <!-- Tabla de permisos con infinite scroll -->
      <div 
        class="permisos-scroll-container"
        @scroll="handleScrollPermisos"
        ref="scrollContainerPermisos"
      >
        <v-table class="permisos-table" fixed-header density="compact">
          <thead>
            <tr>
              <th>Ruta</th>
              <th class="text-center">Permiso</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="permisosUsuario.length > 0">
              <tr 
                v-for="(permiso, index) in permisosUsuario"
                :key="index"
                class="permiso-row"
              >
                <td>
                  <div class="d-flex align-center">
                    <v-icon 
                      size="small" 
                      class="mr-2"
                      :color="permiso.tipo === 'c' ? 'orange' : 'blue'"
                    >
                      {{ permiso.tipo === 'c' ? 'mdi-folder' : 'mdi-file' }}
                    </v-icon>
                    <span>{{ permiso.Ruta || permiso.name }}</span>
                  </div>
                </td>
                <td class="text-center">
                  <v-chip 
                    :color="getColorPermiso(permiso.tipoPermiso)" 
                    size="small"
                    label
                  >
                    {{ getTipoPermisoTexto(permiso.tipoPermiso) }}
                  </v-chip>
                </td>
              </tr>
              
              <!-- Indicador de carga al final -->
              <tr v-if="loadingPermisos">
                <td colspan="2" class="text-center py-4">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="30"
                  ></v-progress-circular>
                  <p class="mt-2 text-caption">Cargando más permisos...</p>
                </td>
              </tr>
              
              <!-- Mensaje cuando no hay más datos -->
              <tr v-if="!loadingPermisos && !hayMasPermisos">
                <td colspan="2" class="text-center py-3 text-caption text-grey">
                  <v-icon size="small">mdi-check-circle</v-icon>
                  No hay más permisos para mostrar
                </td>
              </tr>
            </template>
            
            <template v-else-if="loadingPermisos">
              <tr>
                <td colspan="2" class="text-center py-8">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <p class="mt-2 text-caption">Cargando permisos...</p>
                </td>
              </tr>
            </template>
            
            <template v-else>
              <tr>
                <td colspan="2" class="text-center py-8">
                  <v-icon size="48" color="grey">mdi-lock-off</v-icon>
                  <p class="text-caption text-grey mt-2">No hay permisos asignados</p>
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
      </div>

      <!-- Contador de permisos mostrados -->
      <div v-if="permisosUsuario.length > 0" class="text-center mt-2 text-caption text-grey">
        Mostrando {{ permisosUsuario.length }} de {{ todosLosPermisos.length }} registro(s)
      </div>
    </v-card-text>

    <v-card-actions class="px-6 pb-4">
      <v-spacer></v-spacer>
      <v-btn
        color="#ce501b"
        variant="elevated"
        @click="cerrarModalPermisos"
      >
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


  </v-container>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue'
import axios from '@/plugins/axios'
import Swal from 'sweetalert2'

const campoBusquedaRef = ref(null)
const campoUsuarioRef = ref(null)

const errorDuplicado = ref('') 
const usuarios = ref([])
const loading = ref(false)
const hayMasDatos = ref(true)
const paginaActual = ref(1)
const itemsPorPagina = ref(20)
const scrollContainer = ref(null)
const busqueda = ref('')
const dialogNuevoUsuario = ref(false)
const todosLosUsuarios = ref([])
const guardando = ref(false)
const validFormNuevo = ref(false)
const formNuevoUsuario = ref(null)
const showPasswordNuevo = ref(false)

// Datos del nuevo usuario
const nuevoUsuario = ref({
  usuario: '',
  password: '',
  correo: '',
  idGrupo: null,
  idOficina: null,
  emailActivo: false,
  inhabilitado: false,
  flagDirectory: false
})


const handleKeyboardGlobal = (event) => {
  // Alt + N → abrir modal Nuevo Usuario
  if (event.altKey && event.code === 'KeyN') {
    event.preventDefault()
    if (!dialogNuevoUsuario.value && !dialogVerPermisos.value) {
      abrirModalNuevoUsuario()
    }
  }

  // Alt + G → guardar/actualizar usuario
  if (event.altKey && event.code === 'KeyG') {
    event.preventDefault()
    if (dialogNuevoUsuario.value) {
      guardarUsuario()
    }
  }

  //Alt + B → enfocar buscador
  if (event.altKey && event.code === 'KeyB') {
    event.preventDefault()
    if (!dialogNuevoUsuario.value && !dialogVerPermisos.value) {
      const input = campoBusquedaRef.value?.$el?.querySelector('input')
      if (input) input.focus()
    }
  }

  // ESC → cerrar modal
  if (event.key === 'Escape') {
    if (dialogNuevoUsuario.value) {
      event.preventDefault()
      cerrarModal()
    }
    if (dialogVerPermisos.value) {
      event.preventDefault()
      cerrarModalPermisos()
    }
  }
}


// Listas para los selectores
const grupos = ref([])
const oficinas = ref([])

onMounted(async () => {
  await cargarUsuarios()
  await cargarGrupos()
  await cargarOficinas()
  document.addEventListener('keydown', handleKeyboardGlobal)
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyboardGlobal)
})

const cargarGrupos = async () => {
  try {
    const response = await axios.get('/api/Grupos/list-grupo')
    //console.log('Response grupos:', response.data)        //Usarlo solo para ver los errores en el testeo de Software
    if (response.data.success) {
      // Transformar para asegurar el formato correcto
      grupos.value = response.data.data.map(g => ({
        idGrupo: g.idGrupo || g.IdGrupo,
        grupo: g.grupo || g.Grupo
      }))
      //console.log('Grupos transformados:', grupos.value)    //Usarlo solo para ver los errores en el testeo de Software
    }
  } catch (error) {
    //console.error('Error al cargar grupos:', error)    //Usarlo solo para ver los errores en el testeo de Software
  }
}


const cargarOficinas = async () => {
  try {
    const response = await axios.get('/api/Oficinas/list-oficinas')
    //console.log('Response oficinas:', response.data)          //Usarlo solo para ver los errores en el testeo de Software
    if (response.data.success) {
      // Transformar para asegurar el formato correcto
      oficinas.value = response.data.data.map(o => ({
        idOficina: String(o.idOficina), // ← Forzar string
        oficina: o.oficina
      }))
      //console.log('Oficinas transformadas:', oficinas.value)      //Usarlo solo para ver los errores en el testeo de Software
    }
  } catch (error) {
    //console.error('Error al cargar oficinas:', error)       //Usarlo solo para ver los errores en el testeo de Software
  }
}

const cargarUsuarios = async () => {
  if (loading.value || !hayMasDatos.value) return
  
  loading.value = true
  
  try {
    if (todosLosUsuarios.value.length === 0) {
      const response = await axios.get('/api/Users/list-usuarios')
      
      if (response.data.success) {
        todosLosUsuarios.value = response.data.data
        //console.log('Usuarios cargados:', todosLosUsuarios.value.length)      //Usarlo solo para ver los errores en el testeo de Software
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudieron cargar los usuarios',
          customClass: {
           title: 'swal-title-custom',
           container: 'swal-sobre-modal'
          }
        })
        return
      }
    }
    
    const inicio = (paginaActual.value - 1) * itemsPorPagina.value
    const fin = inicio + itemsPorPagina.value
    const itemsPaginados = todosLosUsuarios.value.slice(inicio, fin)
    
    if (itemsPaginados.length > 0) {
      usuarios.value = [...usuarios.value, ...itemsPaginados]
      paginaActual.value++
    }
    
    if (fin >= todosLosUsuarios.value.length) {
      hayMasDatos.value = false
    }
    
  } catch (error) {
    //console.error('Error al cargar usuarios:', error)      //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar los usuarios',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
      }
    })
  } finally {
    loading.value = false
  }
}

const handleScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target
  if (scrollTop + clientHeight >= scrollHeight * 0.8) {
    cargarUsuarios()
  }
}

const recargarDesdeInicio = () => {
  usuarios.value = []
  todosLosUsuarios.value = []
  paginaActual.value = 1
  hayMasDatos.value = true
  cargarUsuarios()
}

const usuariosFiltrados = computed(() => {
  if (!busqueda.value) {
    return usuarios.value
  }
  
  const termino = busqueda.value.toLowerCase()
  return usuarios.value.filter(usuario => 
    usuario.idUsuario?.toLowerCase().includes(termino) ||
    usuario.usuario?.toLowerCase().includes(termino) ||
    usuario.grupo?.toLowerCase().includes(termino) ||
    usuario.nombreOficina?.toLowerCase().includes(termino)
  )
})

const filtrarUsuarios = () => {
  // Filtrado automático con computed
}


// ========================================
// VARIABLES - Agregar modo edición
// ========================================
const modoEdicion = ref(false) // ← NUEVO: Para saber si estamos editando
const usuarioEditando = ref(null) // ← NUEVO: Usuario que se está editando

// ========================================
// MÉTODOS - Actualizar para soportar edición
// ========================================

const abrirModalNuevoUsuario = () => {
  modoEdicion.value = false
  errorDuplicado.value = '' 
  limpiarFormulario()
  dialogNuevoUsuario.value = true
  nextTick(() => {
    setTimeout(() => {
      const input = campoUsuarioRef.value?.$el?.querySelector('input')
      if (input) input.focus()
    }, 100)
  })
}


const editarUsuario = async (usuario) => {
  //console.log('Editar usuario:', usuario)          //Usarlo solo para ver los errores en el testeo de Software
  
  modoEdicion.value = true
  usuarioEditando.value = usuario
  
  // ✅ Cargar datos completos del usuario desde el API
  try {
    const response = await axios.get(`/api/Users/detalle/${usuario.idUsuario}`)
    
    if (response.data.success) {
      const detalle = response.data.data
      //console.log('Detalle del usuario:', detalle)       //Usarlo solo para ver los errores en el testeo de Software
      
      // Cargar datos en el formulario
      nuevoUsuario.value = {
        usuario: detalle.usuario || '',
        password: '', // Vacío para no cambiar
        correo: detalle.email || '',
        idGrupo: detalle.idGrupo || null,
        idOficina: detalle.idOficina ? String(detalle.idOficina) : null,
        emailActivo: detalle.emailActivo || false,
        inhabilitado: detalle.inhabilitado || false,
        flagDirectory: detalle.flagDirectory || false
      }
      
      dialogNuevoUsuario.value = true
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        iconColor: '#ce501b',
        text: response.data.mensaje || 'No se pudo cargar el usuario',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      })
    }
  } catch (error) {
    //console.error('Error al cargar detalle del usuario:', error)     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Para editar los datos del usuario, necesita darle permiso de accesos al usuario que desea editar en el módulo Seguridad/Accesos.',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
      },
    })
  }
}

const guardarUsuario = async () => {
  const { valid } = await formNuevoUsuario.value.validate()
  
  if (!valid) {
    return
  }

  guardando.value = true

  try {
    if (modoEdicion.value) {
      // ========================================
      // MODO EDICIÓN - Actualizar usuario
      // ========================================
      const payload = {
        id: usuarioEditando.value.idUsuario, // ← ID del usuario a actualizar
        usuario: nuevoUsuario.value.usuario,
        password: nuevoUsuario.value.password || null, // ← null = no cambiar
        correo: nuevoUsuario.value.correo || null,
        idGrupo: nuevoUsuario.value.idGrupo || null,
        idOficina: nuevoUsuario.value.idOficina ? parseInt(nuevoUsuario.value.idOficina, 10) : null, // ✅ Convertir a número
        flagDirectory: nuevoUsuario.value.flagDirectory,
        emailActivo: nuevoUsuario.value.emailActivo,
        inhabilitado: nuevoUsuario.value.inhabilitado
      }

      //console.log('Actualizando usuario:', payload)        //Usarlo solo para ver los errores en el testeo de Software

      const response = await axios.put('/api/Users/actualizar-usuario', payload)

      //console.log('Respuesta recibida:', response.data)     //Usarlo solo para ver los errores en el testeo de Software

      guardando.value = false

      if (response.data.success === true || response.data.Success === true) {
        cerrarModal()
        
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Éxito!',
          text: 'Usuario actualizado correctamente',
          timer: 2500,
          showConfirmButton: true,
          confirmButtonColor: '#ce501b',
          customClass: {
           title: 'swal-title-custom',
           confirmButton: 'swal-btn-confirmar',
           container: 'swal-sobre-modal'
          },
          confirmButtonText: 'OK'
        })

        recargarDesdeInicio()
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response.data.mensaje || response.data.Mensaje || 'No se pudo actualizar el usuario',
        })
      }
    } else {
      // ========================================
      // MODO NUEVO - Crear usuario
      // ========================================
      const payload = {
        usuario: nuevoUsuario.value.usuario,
        password: nuevoUsuario.value.password,
        correo: nuevoUsuario.value.correo || null,
        idGrupo: nuevoUsuario.value.idGrupo || null,
        idOficina: nuevoUsuario.value.idOficina || null,
        flagDirectory: nuevoUsuario.value.flagDirectory,
        emailActivo: nuevoUsuario.value.emailActivo,
        inhabilitado: nuevoUsuario.value.inhabilitado
      }

      //console.log('Creando usuario:', payload)                //Usarlo solo para ver los errores en el testeo de Software

      const response = await axios.post('/api/Users/registrar-usuario', payload)

      //console.log('Respuesta recibida:', response.data)       //Usarlo solo para ver los errores en el testeo de Software

      guardando.value = false

      if (response.data.success === true || response.data.Success === true) {
        cerrarModal()
        
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Éxito!',
          text: 'Usuario registrado correctamente',
          timer: 2500,
          showConfirmButton: true,
          confirmButtonColor: '#ce501b',
          customClass: {
            title: 'swal-title-custom',
            confirmButton: 'swal-btn-confirmar',
            container: 'swal-sobre-modal'
          },
          confirmButtonText: 'OK'
        })

        recargarDesdeInicio()
      } else {

      errorDuplicado.value = response.data.mensaje || response.data.Mensaje || 'No se pudo registrar el usuario'
      }
    }
   } catch (error) {
    guardando.value = false

    // ✅ Si el modal está abierto, mostrar error DENTRO del modal
    if (dialogNuevoUsuario.value) {
      errorDuplicado.value = error.response?.data?.mensaje 
        || error.response?.data?.Mensaje 
        || 'Hubo un problema al guardar el usuario'
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || error.response?.data?.Mensaje || 'Hubo un problema al guardar el usuario',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      })
    }
   }
}

// ✅ AGREGAR AQUÍ:
// Reglas de validación para password
const passwordRulesNuevo = [
  v => !!v || 'Clave es requerida',
  v => (v && v.length >= 6) || 'Mínimo 6 caracteres'
]

const passwordRulesEdicion = [
  v => !v || v.length >= 6 || 'Si cambia la clave, debe tener mínimo 6 caracteres'
]


const limpiarFormulario = () => {
  nuevoUsuario.value = {
    usuario: '',
    password: '',
    correo: '',
    idGrupo: null,
    idOficina: null,
    emailActivo: false,
    inhabilitado: false,
    flagDirectory: false
  }
  if (formNuevoUsuario.value) {
    formNuevoUsuario.value.reset()
  }
}


const cerrarModal = () => {
  dialogNuevoUsuario.value = false
  modoEdicion.value = false
  usuarioEditando.value = null
  errorDuplicado.value = ''
  limpiarFormulario()
}

const confirmarEliminar = async (usuario) => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: `¿Deseas eliminar el usuario "${usuario.usuario}"?`,
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    confirmButtonText: 'Sí, eliminar',
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    },
    cancelButtonText: 'Cancelar'
  })

  if (result.isConfirmed) {
    eliminarUsuario(usuario)
  }
}

const eliminarUsuario = async (usuario) => {
  //console.log('Eliminar usuario:', usuario)      //Usarlo solo para ver los errores en el testeo de Software
  
  try {
    // ✅ Obtener idUsuario de localStorage
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    
    if (!idUsuarioSesion) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: 'No se pudo obtener la información del usuario en sesión',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      })
      return
    }

    // ✅ Enviar idUsuarioSesion como query parameter
    const response = await axios.delete(
      `/api/Users/eliminar-usuario/${usuario.idUsuario}?idUsuarioSesion=${idUsuarioSesion}`
    )

    //console.log('Respuesta eliminación:', response.data)    //Usarlo solo para ver los errores en el testeo de Software

    if (response.data.success) {
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Eliminado!',
        text: `El usuario "${usuario.usuario}" ha sido eliminado exitosamente.`,
        confirmButtonColor: '#ce501b',
        customClass: {
          title: 'swal-title-custom',
          confirmButton: 'swal-btn-confirmar',
          container: 'swal-sobre-modal'
        },
        timer: 2500,
        showConfirmButton: true
      })

      // Recargar la lista de usuarios
      recargarDesdeInicio()
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudo eliminar el usuario',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      })
    }
  } catch (error) {
    //console.error('Error al eliminar usuario:', error)   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al eliminar el usuario',
    })
  }
}


// Agregar estas variables al inicio
// Variables para permisos con infinite scroll
const dialogVerPermisos = ref(false)
const permisosUsuario = ref([]) // Permisos visibles
const todosLosPermisos = ref([]) // Cache completo
const usuarioSeleccionado = ref(null)
const loadingPermisos = ref(false)
const hayMasPermisos = ref(true)
const paginaActualPermisos = ref(1)
const itemsPorPaginaPermisos = ref(20) // Cargar 20 a la vez
const scrollContainerPermisos = ref(null)

// Método verPermisos actualizado
const verPermisos = async (usuario) => {
  //console.log('Ver permisos:', usuario)     //Usarlo solo para ver los errores en el testeo de Software
  usuarioSeleccionado.value = usuario
  dialogVerPermisos.value = true
  
  // Resetear estado
  permisosUsuario.value = []
  todosLosPermisos.value = []
  paginaActualPermisos.value = 1
  hayMasPermisos.value = true
  
  await cargarPermisos(usuario.idUsuario)
}

const cargarPermisos = async (idUsuario) => {
  if (loadingPermisos.value || !hayMasPermisos.value) return
  
  loadingPermisos.value = true
  
  try {
    // Solo cargar una vez todos los datos
    if (todosLosPermisos.value.length === 0) {
      const response = await axios.get(`/api/Users/permisos/${idUsuario}`)
      
      if (response.data.success) {
        todosLosPermisos.value = response.data.data
        //console.log('Permisos cargados:', todosLosPermisos.value.length)     //Usarlo solo para ver los errores en el testeo de Software
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudieron cargar los permisos',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        })
        loadingPermisos.value = false
        return
      }
    }
    
    // Simular paginación del lado del cliente
    const inicio = (paginaActualPermisos.value - 1) * itemsPorPaginaPermisos.value
    const fin = inicio + itemsPorPaginaPermisos.value
    const itemsPaginados = todosLosPermisos.value.slice(inicio, fin)
    
    if (itemsPaginados.length > 0) {
      permisosUsuario.value = [...permisosUsuario.value, ...itemsPaginados]
      paginaActualPermisos.value++
    }
    
    // Verificar si hay más datos
    if (fin >= todosLosPermisos.value.length) {
      hayMasPermisos.value = false
    }
    
  } catch (error) {
    //console.error('Error al cargar permisos:', error)        //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'Hubo un problema al cargar los permisos',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
      }
    })
  } finally {
    loadingPermisos.value = false
  }
}

const handleScrollPermisos = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target
  
  // Si llegamos al 80% del scroll, cargar más
  if (scrollTop + clientHeight >= scrollHeight * 0.8) {
    cargarPermisos(usuarioSeleccionado.value?.idUsuario)
  }
}

const getTipoPermisoTexto = (tipo) => {
  const tipos = {
    1: 'LECTURA',
    2: 'ESCRITURA',
    3: 'TOTAL'
  }
  return tipos[tipo] || 'DESCONOCIDO'
}

const getColorPermiso = (tipo) => {
  const colores = {
    1: 'blue',      // LECTURA
    2: 'orange',    // ESCRITURA
    3: 'success'    // TOTAL
  }
  return colores[tipo] || 'grey'
}

const cerrarModalPermisos = () => {
  dialogVerPermisos.value = false
  permisosUsuario.value = []
  todosLosPermisos.value = []
  usuarioSeleccionado.value = null
  paginaActualPermisos.value = 1
  hayMasPermisos.value = true
}

</script>

<style scoped>
.usuarios-container {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  padding-right: 8px;
}

.usuarios-container::-webkit-scrollbar {
  width: 8px;
}

.usuarios-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.usuarios-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.usuarios-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.usuarios-table {
  background-color: transparent;
}

.usuarios-table th {
  background-color: #def2ff !important;
  font-weight: bold !important;
  color: #37495f !important;
  white-space: nowrap;
}

.usuario-row {
  transition: background-color 0.2s ease;
}

.usuario-row:hover {
  background-color: rgba(59, 130, 200, 0.05);
}

.usuario-row.inhabilitado {
  opacity: 0.6;
  background-color: rgba(255, 0, 0, 0.05);
}

.usuarios-table td {
  padding: 12px 16px !important;
}

/* Campos amarillos */
:deep(.campo-amarillo .v-field) {
  background-color: #FFFACD !important;
}

.permisos-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #f9f9f9;
}


.permisos-scroll-container {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

/* Personalizar scrollbar */
.permisos-scroll-container::-webkit-scrollbar {
  width: 8px;
}

.permisos-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.permisos-scroll-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.permisos-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.permisos-table {
  background-color: transparent;
}

.permisos-table thead tr th {
  background-color: #E8E9F3 !important;
  font-weight: bold !important;
  position: sticky;
  top: 0;
  z-index: 1;
  color: #37495f !important;
}

.permiso-row {
  transition: background-color 0.2s ease;
}

.permiso-row:hover {
  background-color: rgba(59, 130, 200, 0.05);
}


</style>

<style>

.swal-sobre-modal {
  z-index: 9999 !important;
}

.swal-sobre-modal .swal2-popup {
  z-index: 9999 !important;
}

.swal-sobre-modal + .swal2-backdrop-show {
  z-index: 9998 !important;
}
</style>

<style>

.swal-title-custom {
  color: #004d82 !important;
  font-size: 1.3rem !important;
}

.swal-text-custom {
  color: #555555 !important;
  font-size: 0.95rem !important;
}

.swal-btn-custom {
  background-color: #ce501b !important;
  color: #ffffff !important;
  border-radius: 6px !important;
  padding: 8px 24px !important;
}

.swal-btn-custom:hover {
  background-color: #a83d14 !important;
}

.swal-btn-confirmar {
  color: white !important;
}

</style>